import { createFileRoute, redirect, useNavigate } from '@tanstack/react-router'
import { DashboardPage } from '../pages/DashboardPage'
import { useAuthStore } from '../stores/auth-store'

export const Route = createFileRoute('/dashboard')({
  component: Dashboard,
  beforeLoad: () => {
    const { isAuthenticated } = useAuthStore.getState()
    if (!isAuthenticated) {
      throw redirect({
        to: '/login',
      })
    }
  },
})

function Dashboard() {
  const navigate = useNavigate()

  const handleLogout = () => {
    navigate({ to: '/login' })
  }

  return (
    <DashboardPage onLogout={handleLogout} />
  )
}